<template>
    <section>
        <div>
            <h1>It's me, Pedro Henrique!</h1>
            <p>I'm 26 years old, originally from Brazil, São Paulo and I'm currently living in Lisbon, Portugal.</p>
            <p>A monochromatic-lover, weird-looking, tech-savvy, go-getter, dog-friendly, achievement-seeker and few other fancy-looking two-word adjectives more, but let's stop here for now.</p>
            <p>When I'm not chasing my dream to become a Pokémon Champion, I'm developing my front-end skills. I'm aways trying to catch up with the latest trendings regarding technologies, UX/UI good practices and gaming.</p>
            <p>My tech stack includes, but is not limited to:</p>
            <ul>
                <li>HTML5</li>
                <li>CSS3</li>
                <li>ES7</li>
                <li>Vue.js</li>
            </ul>
            <p>
                I have a degree in Analysis and System Development by
                <a
                    href="https://www.fiap.com.br/"
                    class="link"
                    target="_blank"
                >FIAP</a>. For courses, I have UX on web platforms and Project management using SCRUM by
                <a
                    href="https://www.pucsp.br/home"
                    class="link"
                    target="_blank"
                >PUC</a>. There are few others you can check here
                <a
                    href="https://www.linkedin.com/in/developer-pedro-henrique"
                    class="link"
                    target="_blank"
                >here</a>.
            </p>
        </div>
    </section>
</template>

<script>
export default {
    name: "About"
};
</script>

<style scoped lang="scss">
li {
    margin-left: 20px;
}
</style>
